module.exports = __webpack_public_path__ + "img/ssangyong_thmbnail.81056e1a.png";